import React from 'react';
import cx from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import type { ZolaFileResponseType } from 'actions/types/UploadcareActions';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import type { SharedEntityProps } from '../types';

import EditPageEntityDetail from './EditPageEntityDetail';

import { SortableItemContainer, StyledReorderIcon } from './EditPageSortableList.styles';

type EditPageSortableItemProps = {
  entity: GenericEntityType;
  entityDetailProps: SharedEntityProps;
  id: string;
  isMultiPhoto?: boolean;
  removePhotoFromMultiQueue?: (id: number) => void;
  updatePhotoInMultiQueue?: (id: number, newPhoto: ZolaFileResponseType) => void;
  updatePhotoCaptionInMultiQueue?: (id: number, newCaption: string) => void;
};

const EditPageSortableItem = ({
  entity,
  entityDetailProps,
  id,
  isMultiPhoto,
  removePhotoFromMultiQueue,
  updatePhotoInMultiQueue,
  updatePhotoCaptionInMultiQueue,
}: EditPageSortableItemProps): JSX.Element => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <SortableItemContainer
      className="edit-page-entity-item"
      ref={setNodeRef}
      style={style}
      isDragging={isDragging}
    >
      <StyledReorderIcon width={24} height={24} {...listeners} {...attributes} title="" />
      <EditPageEntityDetail
        entity={entity}
        entityDetailProps={entityDetailProps}
        isMultiPhoto={isMultiPhoto}
        removePhotoFromMultiQueue={removePhotoFromMultiQueue}
        updatePhotoInMultiQueue={updatePhotoInMultiQueue}
        updatePhotoCaptionInMultiQueue={updatePhotoCaptionInMultiQueue}
      />
    </SortableItemContainer>
  );
};

type AddClassType = {
  addClass?: string;
};

type EntityNameProps = AddClassType & { name?: string };
export const EntityName: React.FC<EntityNameProps> = ({ children, name, addClass }) => {
  const classNames = cx('entity-name', { [`${addClass}`]: addClass });
  return <h4 className={classNames}>{name || children}</h4>;
};

type EntityTypeProps = AddClassType & { type?: string };
export const EntityType: React.FC<EntityTypeProps> = ({ children, type, addClass }) => {
  const classNames = cx('entity-type', { [`${addClass}`]: addClass });
  return <div className={classNames}>{type || children}</div>;
};

type EntityDescriptionProps = AddClassType & { description?: string };
export const EntityDesciption: React.FC<EntityDescriptionProps> = ({
  children,
  description,
  addClass,
}) => {
  const classNames = cx('entity-description', { [`${addClass}`]: addClass });
  return <div className={classNames}>{description || children}</div>;
};

export default EditPageSortableItem;
